// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"d7a9693a","502":"aa9cbc07","730":"97792f0f","917":"0aae1281"}[chunkId] + ".chunk.js";
};